
//省市区三级联动 混入
export default {
    data(){
        return {
            regionArr:{
                pro:[],
                city:[],
                area:[],
            },
            regionVal:{
                pro:null,
                city:null,
                area:null,
            }
        }
    },
    mounted(){
        this.getRegion('pro', 0);
    },
    methods:{
        getRegion(type, id = 0){
            // this.$post('/api/area',{pid: id}).then(res=>{
            //     this.regionArr[type] = res.data;
            // })
            if(type == 'pro'){
                this.$post('/api/area',{pid: 0}).then(res=>{
                    this.regionArr[type] = res.data;
                    // console.log(this.regionArr.pro);
                })
            }else{
                this.$post('/api/areashaixuan',{str: id}).then(res=>{
                    this.regionArr[type] = res.data;
                    // console.log(this.regionArr.pro);
                })
            }
        } 
    },
    watch:{
        'regionVal.pro'(val){
            if(val) this.getRegion('city', val);
            this.regionVal.city = null;
            this.regionArr.city = [];
            this.regionVal.area = null;
            this.regionArr.area = [];
        },
        'regionVal.city'(val){
            if(val) this.getRegion('area', val);
            this.regionVal.area = null;
            this.regionArr.area = [];
        },
        // 'regionVal.area'(val){},
    }
}


// WEBPACK FOOTER //
// ./src/mixin/region.js